(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/physical-tickets/components/physical-tickets-form/physical-tickets-form.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/physical-tickets/components/physical-tickets-form/physical-tickets-form.js');
"use strict";


const SelectPhysicalTickets = svs.ticket_partner.physicalTickets.physicalTicketsForm.selectPhysicalTickets.SelectPhysicalTickets;
const CustomerInformation = svs.ticket_partner.physicalTickets.physicalTicketsForm.customerInformation.CustomerInformation;
const AcceptTerms = svs.ticket_partner.sharedComponents.input.AcceptTerms;
const ButtonRowSubmit = svs.ticket_partner.sharedComponents.buttonRow.ButtonRowSubmit;
const _svs$ticket_partner$p = svs.ticket_partner.physicalTickets.constants.FORMS,
  HEADER = _svs$ticket_partner$p.HEADER,
  ORDER_LABEL = _svs$ticket_partner$p.ORDER_LABEL;
const _svs$ticket_partner$p2 = svs.ticket_partner.physicalTickets.actions,
  ACCEPT_TERMS = _svs$ticket_partner$p2.ACCEPT_TERMS,
  ORDER_SUCCESS = _svs$ticket_partner$p2.ORDER_SUCCESS;
const Form = svs.ui.reactForm.Form;
const _React = React,
  useContext = _React.useContext;
const GridRow = svs.ui.ReactGrid.GridRow;
const createPhysicalOrderRequest = svs.ticket_partner.physicalTickets.utils.createPhysicalOrderRequest;
const PHYSICAL_TICKETS_RECEIPT = svs.ticket_partner.constants.routes.PHYSICAL_TICKETS_RECEIPT;
const PhysicalTicketsForm = _ref => {
  let history = _ref.history;
  const _useContext = useContext(svs.ticket_partner.PhysicalTicketsContext),
    state = _useContext.state,
    dispatch = _useContext.dispatch;
  const handleSubmit = (e, formData) => {
    e && e.preventDefault();
    if (_.values(formData).some(field => !field.isValid)) {
      return;
    }
    const onConfirmOrder = async () => {
      svs.ui.loader.show();
      try {
        const orderDetails = createPhysicalOrderRequest(state);
        await svs.ticket_partner.services.orderPhysical(orderDetails);
        dispatch({
          type: ORDER_SUCCESS,
          payload: true
        });
        history.push(PHYSICAL_TICKETS_RECEIPT);
      } catch (e) {
        svs.ticket_partner.utils.showErrorDialog(svs.ticket_partner.services.mapOrderphysicalError(e));
      }
      svs.ui.loader.hide();
    };
    const sum = Object.values(state.articles).reduce((acc, _ref2) => {
      let price = _ref2.price,
        count = _ref2.count;
      return price * count + acc;
    }, 0);
    const rows = Object.values(state.articles).filter(_ref3 => {
      let count = _ref3.count;
      return count > 0;
    }).map(_ref4 => {
      let articleId = _ref4.articleId,
        count = _ref4.count;
      return {
        articleId,
        count
      };
    });
    svs.ticket_partner.utils.showSummaryDialog(onConfirmOrder, {
      sum,
      rows
    }, svs.ticket_partner.data.articles.ticketsPhysical);
  };
  const handleAcceptTermsChange = _ref5 => {
    let target = _ref5.target;
    dispatch({
      type: ACCEPT_TERMS,
      payload: target.checked
    });
  };
  return React.createElement(Form, {
    onSubmit: handleSubmit
  }, React.createElement("h1", {
    className: "f-bold"
  }, HEADER), React.createElement(SelectPhysicalTickets, {
    articles: state.articles,
    dispatch: dispatch
  }), React.createElement(CustomerInformation, {
    dispatch: dispatch,
    state: state.adressForm
  }), React.createElement(GridRow, {
    className: "padding-top-1"
  }, React.createElement(AcceptTerms, {
    handleOnChange: handleAcceptTermsChange,
    state: state
  })), React.createElement("div", {
    className: "margin-3"
  }, React.createElement(ButtonRowSubmit, {
    label: ORDER_LABEL
  })));
};
svs.ticket_partner.physicalTickets.physicalTicketsForm.PhysicalTicketsForm = PhysicalTicketsForm;

 })(window);